module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[48]47.dbc8e40.woff2";